import Joi from '@hapi/joi'

export const DivisionSummaryReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    divisionID: Joi.number().label("Division").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),
    currentID: Joi.number().invalid(0).required().label("Current").messages({
        "any.invalid": `Select Current`,
        "any.required": `Current required`
    }),
    statusID: Joi.number().label("Status").messages({
        "any.invalid": `Select Current`,
        "any.required": `Status required`
    }),
    transactionTypeID: Joi.number().label("Transaction Typr").messages({
        "any.invalid": `Select Transaction Type`,
        "any.required": `Transaction Type required`
    }),
    toDate: Joi.string().invalid("").required().label("To Date").messages({
        "any.required": `Date required`
    }),
    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.required": `Date required`
    })
}